(() => {
  const form = document.querySelector('.section-form-contact form');
  if (!form) return;

  const fields = [...form.querySelectorAll('[data-lc-contact-typing]')];
  const message = form.querySelector('.lc-contact-message textarea');
  if (message) {
    message.dataset.lcContactTyping = '';
    message.dataset.placeholderText = message.placeholder;
    fields.push(message);
  }

  const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  let started = false;

  const revealPlaceholder = (field, delay) => {
    const text = field.dataset.placeholderText || '';
    if (!text) return;

    field.placeholder = '';
    window.setTimeout(() => {
      let index = 0;
      const timer = window.setInterval(() => {
        if (field.matches(':focus') || field.value) {
          field.placeholder = text;
          window.clearInterval(timer);
          return;
        }

        index += 1;
        field.placeholder = text.slice(0, index);
        if (index >= text.length) window.clearInterval(timer);
      }, 42);
    }, delay);
  };

  const start = () => {
    if (started) return;
    started = true;

    fields.forEach((field, index) => {
      const text = field.dataset.placeholderText || '';
      field.addEventListener('focus', () => { field.placeholder = text; });
      if (reducedMotion) field.placeholder = text;
      else revealPlaceholder(field, index * 260);
    });
  };

  if (!('IntersectionObserver' in window)) {
    start();
    return;
  }

  const observer = new IntersectionObserver((entries) => {
    if (!entries.some((entry) => entry.isIntersecting)) return;
    start();
    observer.disconnect();
  }, { threshold: 0.18 });

  observer.observe(form);
})();
